<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" visibleCreate @stored="stored">
          <template v-slot:action="{ item }">
            <v-btn v-if="item.updateVisible" class="mr-2" depressed small @click.stop="updated(item)" color="primary">編集</v-btn>
            <v-btn v-if="item.updateVisible" class="mr-2" depressed small @click.stop="deleted(item)" color="error">削除</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
        @deleted="submit" @canceled="dialogCancel"
      />
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import SystemNotificationsApi from "@/api/system-notifications-api";
import CustomDataTable from "@/components/custom_ui/CustomDataTable";
import CustomDialog from "@/components/custom_ui/CustomDialog";
import statusList from "@/helpers/const";

export default {
  name: "SystemNotification",
  components: {
    CustomDataTable,
    CustomDialog
  },
  props: ["user"],
  data: () => ({
    // 共通コンポーネント: データテーブル関連
    loading: false,
    tableName: "システムお知らせ情報",
    headers: [
      { text: "表示予定日", value: "scheduled_display_date", sortable: false, align: 'left' },
      { text: "タイトル", value: "title", sortable: false, align: 'left' },
      { text: "作成日", value: "create_date", sortable: false, align: 'left' },
      { text: 'アクション', value: 'action', sortable: false, align: 'left'},
    ],
    items: [],

    // 削除ダイアログ
    dialogMaxWith: 500,
    dialogTitle: "",
    dialogItems: [],
    dialogDrawer: false,
    deleteId: null,

    // 権限
    updateVisible: true,
    deleteVisible: true
  }),
  created() {
    this.initialize();
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.isLoading();
      this.systemNotificationsApi = new SystemNotificationsApi();
      const promise = this.systemNotificationsApi.list();
      const today = new Date();
      promise
        .then(response => {
          this.items = response.data.body.system_notifications_master_list;
          for (var item of this.items) {
            const display_period = item.display_period;
            const now = today.getFullYear() + "/" + ("00" + (today.getMonth() + 1)).slice(-2) + "/" + ("00" + (today.getDate())).slice(-2);
            const flag = (display_period < now) ? false : true;
            item.updateVisible = flag;
            item.deleteVisible = flag;
          }
        })
        .catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error", error.response.data.message);
              this.$router.push({ name: "Dashboard" });
            } else {
              this.$emit("error", error.response.data.message);
            }
          } else {
            this.$emit("error", "サーバーエラーが発生しました。");
          }
        })
        .finally(() => {
          this.isLoading();
        });
    },
    // 新規作成ボタン押下時
    stored() {
      this.$router.push({ name: "SystemNotificationcEntry" });
    },
    // 編集ボタン押下時
    updated(item) {
      this.$router.push({
        name: "SystemNotificationEdit",
        params: { id: item.id }
      });
    },
    // 削除ボタン押下時
    deleted(item) {
      this.deleteId = item.id;
      this.dialogTitle = "削除しますか？";
      this.dialogItems = [
          { name: "表示予定日", value: item.scheduled_display_date },
          { name: "タイトル", value: item.title },
          { name: "作成日", value: item.create_date },
      ];
      this.dialogDrawer = true;
    },
    dialogCancel() {
      this.dialogDrawer = false;
    },
    // ダイアログ削除ボタン押下時
    submit() {
      this.isLoading();
      // システムお知らせ情報IDを選択済みアイテム情報から取得
      const promise = this.systemNotificationsApi.delete(this.deleteId);

      promise.then(response => {
        this.items = this.items.filter(item => {
          return item.id !== this.deleteId;
        });
        this.deleteId = null;
        this.dialogDrawer = false;
        this.$emit("success", response.data.message);
      })
      .catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.dialogDrawer = false;
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      })
      .finally(() => {
        this.isLoading();
      });
    }
  }
};
</script>
